import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import { post, get, baseUrl, storageLabel, websocketUrl } from '@/utils/axios.js'
import { notification } from 'ant-design-vue';
import { message } from 'ant-design-vue';
import '@/style/variable.css'
import CButton from '@/views/components/c-button.vue'
import i18n from './utils/i18n.js';

const app = createApp(App);
app.use(router);
app.use(Antd)
app.config.globalProperties.baseUrl = baseUrl
app.config.globalProperties.websocketUrl = websocketUrl
app.config.globalProperties.post = post
app.config.globalProperties.get = get
app.config.globalProperties.storageLabel = storageLabel
app.config.globalProperties.notification = notification
app.config.globalProperties.message = message
app.config.globalProperties.phoneFlag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
app.config.globalProperties.companyConfig = {
  code: process.env.VUE_APP_COMPANY_CODE,
  productName: process.env.VUE_APP_PRODUCT_NAME,
  productAbbreviation: process.env.VUE_APP_PRODUCT_ABBREVIATION || '', // 可选字段
  icon: process.env.VUE_APP_ICON,
  icp: process.env.VUE_APP_ICP,
  subject: process.env.VUE_APP_SUBJECT,
};


app.component('c-button', CButton);
app.use(i18n);
app.mount('#app');